import { render, staticRenderFns } from "./DiagnosesEdit.vue?vue&type=template&id=6272c984"
import script from "./DiagnosesEdit.vue?vue&type=script&lang=js"
export * from "./DiagnosesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports